import React from 'react';
import { Button, Flex, FlexProps, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

interface Props extends Pick<FlexProps, 'mt'> {
  searchText: string;
  onSearchChange: (value: string) => void;
  onAdd: () => void;
}

export const FileActionBar: React.FC<Props> = ({ searchText, onSearchChange, onAdd, mt }) => {
  const { t } = useTranslation();
  return (
    <Flex w="1040px" align="center" justify="space-between" mt={mt}>
      <InputGroup w="min(475px, 100%)">
        <InputLeftElement>
          <SearchIcon color="#00AAFF" />
        </InputLeftElement>
        <Input
          placeholder={t('file.searchPlaceholder')}
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          fontFamily="'Open Sans', sans-serif"
          fontSize="16px"
        />
      </InputGroup>
      <Button
        h="34px"
        px="16px"
        bg="#00AAFF"
        color="#FFFFFF"
        borderRadius="4px"
        fontFamily="'Open Sans', sans-serif"
        fontSize="16px"
        fontWeight={600}
        _hover={{ bg: '#0099E6' }}
        _active={{ bg: '#0088CC' }}
        onClick={onAdd}
      >
        {t('file.add')}
      </Button>
    </Flex>
  );
};

export default FileActionBar;
